import type { ProOpenJobCount as ProOpenJobCountProto } from '@taxfyle/api-internal/internal/job_stats_pb'
import type { ProOpenJobCount } from '@/features/jobs/dashboard/job-stats/pro-open-job-count'

export function mapProOpenJobCountProtoToProOpenJobCount(
  proto: ProOpenJobCountProto,
): ProOpenJobCount {
  return {
    workspaceId: proto.getWorkspaceId(),
    total: proto.getTotal(),
  }
}
